import { Form, Select } from "antd";
import React, { useRef, useState } from "react";

function SetHeader() {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const [countyId, setCountyId] = useState(null);
  return (
    <div>
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        className="w-full  "
        form={form}
      >
        <div className="mt-[1.5rem] grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[2.25rem]">
          <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Year</span>
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              // options={
              //   counties?.length > 0 &&
              //   counties?.map((item) => ({
              //     value: item?.countyName,
              //     label: item?.countyName,
              //   }))
              // }
              value={countyId}
              onChange={(value) => setCountyId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
          <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Type</span>
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              // options={
              //   counties?.length > 0 &&
              //   counties?.map((item) => ({
              //     value: item?.countyName,
              //     label: item?.countyName,
              //   }))
              // }
              value={countyId}
              onChange={(value) => setCountyId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>

          <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Month</span>
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              //   options={
              //     counties?.length > 0 &&
              //     counties?.map((item) => ({
              //       value: item?.countyName,
              //       label: item?.countyName,
              //     }))
              //   }
              value={countyId}
              onChange={(value) => setCountyId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
        </div>
      </Form>
    </div>
  );
}

export default SetHeader;
